import Request from '@/api/request';

/**
 * @description: user login api
 */

export const getManuscripts = async (params, start = 0, limit = 100) => {
  const requestParams = {
    ...params,
    filter: {
      ...params.filter,
      status: 100
    },
    sort: {
      'id' : -1,
    },
    pagination: {
      'start' : start,
      'limit' : limit,
    }
  };
  return await Request.get('/v1/manuscripts', requestParams).then((res) => {
    return res;
  });
};

export const getManuscript = async (eventid, id) => {
  let params = {};
  return await Request.get('/v1/events/'+eventid+'/manuscripts/' + id, params).then((res) => {
    return res;
  });
};

export const putManuscript = async (eventid, id, params) => {
  return await Request.put('/v1/events/'+eventid+'/manuscripts/'+id, params).then((res) => {
      return res;
  });
}

export const postManuscript = async (eventid, params) => {
  return await Request.formpost('/v1/events/'+eventid+'/manuscripts', params).then((res) => {
    return res;
  });
}

export const putManuscriptOffline = async (id) => {
  return await Request.put('/v1/manuscripts/'+id + '/offline', {}).then((res) => {
      return res;
  });
}

export const putManuscriptOnline = async (id) => {
  return await Request.put('/v1/manuscripts/'+id + '/online', {}).then((res) => {
      return res;
  });
}


export const getEventManuscripts = async (eventid, params) => {
  return await Request.get('/v1/events/'+eventid+'/manuscripts', params).then((res) => {
    return res;
  });
};

export const postEventManuscript = async (eventid, manuscriptid, params) => {
  return await Request.formpost('/v1/events/'+eventid+'/manuscripts/from/'+manuscriptid, params).then((res) => {
      return res;
  });
};

export const putEventManuscript = async (eventid, id, params) => {
  return await Request.put('/v1/events/'+eventid+'/manuscripts/'+id, params).then((res) => {
      return res;
  });
}

export const postEventManuscriptCover = async (eventid, filecover, params) => {
  const manuscriptid = params.manuscriptid;
  let uri = '/v1/events/'+eventid+'/manuscripts/'+manuscriptid+'/cover';
  return await Request.fileformpost(uri, 'filecover', filecover).then((res) => {
      return res;
  });
}

export const putManuscriptMarkdown = async (manuscriptid, params) => {
  params.type = 0;
  return await Request.put('/v1/manuscripts/'+manuscriptid+'/richtext', params).then((res) => {
    return res;
  });  
};

export const getManuscriptMarkdown = async (manuscriptid) => {
  return await Request.get('/v1/manuscripts/'+manuscriptid+'/richtext',{type:0}).then((res) => {
    return res;
  });  
};